export const processFieldList = [{
    id: 'id',
    name: '流程实例Id'
}, {
    id: 'name',
    name: '流程名称'
}, {
    id: 'started',
    name: '开始时间'
}, {
    id: 'ended',
    name: '结束时间'
}, {
    id: 'processInstanceDurTime',
    name: '流程耗时'
}, {
    id: 'processServiceId',
    name: '流程模板ID'
}, {
    id: 'processServiceName',
    name: '流程模板名称'
}, {
    id: 'startedByUserId',
    name: '发起人'
}, {
    id: 'assigneeUserId',
    name: '负责人'
}, {
    id: 'processStatus',
    name: '流程状态'
}];

export const taskFieldList = [{
    id: 'id',
    name: '任务Id'
}, {
    id: 'name',
    name: '任务名称'
}, {
    id: 'created',
    name: '任务开始时间'
}, {
    id: 'endDate',
    name: '任务结束时间'
}, {
    id: 'duration',
    name: '任务耗时'
}, {
    id: 'taskInstanceDurationTime',
    name: '任务耗时(详细)'
}, {
    id: 'taskDurationTime',
    name: '任务耗时(小时)'
}, {
    id: 'processInstanceName',
    name: '所属流程名称'
}, {
    id: 'processInstanceId',
    name: '所属流程ID'
}, {
    id: 'processServiceName',
    name: '流程模板名称'
}, {
    id: 'assigneeUserId',
    name: '负责人'
}, {
    id: 'taskStateLabel',
    name: '任务状态'
}, {
    id: 'processInstanceCreated',
    name: '流程开始时间'
}, {
    id: 'processInstanceEndDate',
    name: '流程结束时间'
}, {
    id: 'processInstanceDurTime',
    name: '流程耗时'
}, {
    id: 'processInstanceDurationTimeView',
    name: '流程耗时(详细)'
}, {
    id: 'processInstanceDurationHourView',
    name: '流程耗时(小时)'
}, {
    id: 'processStatus',
    name: '流程状态'
}, {
    id: 'departmentId',
    name: '部门id'
}, {
    id: 'departmentName',
    name: '所属部门'
}, {
    id: 'roleId',
    name: '角色id'
}, {
    id: 'roleName',
    name: '角色'
}, {
    id: 'processStartedByUserId',
    name: '流程发起人'
}];

export const approvalFieldList = [{
    id: 'busiProcessServiceName',
    name: '所属流程的流程模板'
}, {
    id: 'busiProcessInstanceName',
    name: '流程名称'
}, {
    id: 'processInstanceId',
    name: '流程实例ID'
}, {
    id: 'taskName',
    name: '流程任务'
}, {
    id: 'templateName',
    name: '审批模板'
}, {
    id: 'approvalTypeName',
    name: '审批类型(业务分类)'
}, {
    id: 'id',
    name: '审批实例ID'
}, {
    id: 'approvalName',
    name: '审批名称'
}, {
    id: 'created',
    name: '开始时间'
}, {
    id: 'endDate',
    name: '结束时间'
}, {
    id: 'approvalInstanceDurTime',
    name: '流程耗时(毫秒)'
}, {
    id: 'approvalInstanceDurHour',
    name: '流程耗时(小时)'
}, {
    id: 'approvalInstanceDurDetail',
    name: '流程耗时(详细)'
}, {
    id: 'createdBy',
    name: '发起人'
}, {
    id: 'approvalStatus',
    name: '审批状态标识'
}, {
    id: 'approvalStatusLabel',
    name: '审批状态'
}, {
    id: 'approvalRemarks',
    name: '审批描述'
}, {
    id: 'applyUserName',
    name: '申请人姓名'
}, {
    id: 'applyUserDept',
    name: '申请人所属部门'
}, {
    id: 'approvalUserName',
    name: '审批人姓名'
}, {
    id: 'executionOrder',
    name: '审批顺序(常规)'
}, {
    id: 'executionGroupOrder',
    name: '审批顺序(或签/会签)'
}, {
    id: 'approvalResultLabel',
    name: '审批结果'
}, {
    id: 'approvalDate',
    name: '审批时间'
}, {
    id: 'approvalDurationTime',
    name: '审批耗时(毫秒)'
}, {
    id: 'approvalDurationHour',
    name: '审批耗时(小时)'
}, {
    id: 'approvalDurationDetail',
    name: '审批耗时(详细)'
} ];

export const departmentFieldList = [{
    id: 'id',
    name: '部门Id'
}, {
    id: 'label',
    name: '部门名称'
}, {
    id: 'deptNameShort',
    name: '部门简称'
}, {
    id: 'deptMasterUserIds',
    name: '部门负责人'
}, {
    id: 'deptMobile',
    name: '部门电话'
}, {
    id: 'remarks',
    name: '备注'
}, {
    id: 'created',
    name: '创建时间'
}, {
    id: 'createdBy',
    name: '创建人'
}];



// WEBPACK FOOTER //
// ./src/components/ProcessDataLinkConfig/default-data.js